export const CONTACTS = 1
export const HELP = 2
export const MARKET = 3
export const FREIGHT = 4
export const OTHER = 5
export const LAST = 6
export const SEARCH = 7
